import { StyleSheet } from 'react-native';
import theme from '@/config/theme';

export const styles = StyleSheet.create({
  wrapper: {
    alignSelf: 'center',
  },
  portalContainer: {
    alignItems: 'center',
    alignSelf: 'center',
    width: '50%',
    rowGap: theme.spacings.xl,
    marginVertical: theme.spacings.lg,
  },
  portalTitle: {
    fontWeight: 'bold',
    fontSize: theme.fontSizes['2xl'],
  },
  infoSection: {
    alignItems: 'center',
    rowGap: theme.spacings.md,
  },
  infoText: {
    fontSize: theme.fontSizes.xl,
  },
  bold: {
    fontWeight: 'bold',
  },
  infoTextCenter: {
    textAlign: 'center',
    fontSize: theme.fontSizes.xl,
  },
  manageButton: {
    backgroundColor: theme.colors.primary,
    padding: theme.spacings.sm,
    borderRadius: theme.borderRadii.md,
  },
  manageButtonText: {
    color: theme.colors.white,
    fontSize: theme.fontSizes.xl,
  },
});
